<template>
    <div class="shortContent">
        <div class="shortBox column">
            <div class="shortText">想要短剧视频爆，就来使用视星号 视星号是一款集短剧创作、发布、推广于一体的一站式短剧App应用。它不仅提供了一个广阔的短剧创作平台，让用户可以自由创作、发布自己的短剧作品，同时也提供了一系列短剧推广工具，帮助用户将作品推广至更广泛的观众群体。 用户可以通过分享到社交媒体、使用视星号的推广功能，将自己的短剧作品推广至更多的观众群体。视星号还提供了收益实时数据，让用户能够更好地了解自己短剧作品的受众情况、观看数据等，以便更好地调整推广策略。</div>
            <el-image :src="require('@/assets/image/short01.jpg')" fit="cover" class="shortImg"></el-image>
            <el-image :src="require('@/assets/image/short02.jpg')" fit="cover" class="shortImg"></el-image>
            <el-image :src="require('@/assets/image/short03.jpg')" fit="cover" class="shortImg"></el-image>
            <el-image :src="require('@/assets/image/short04.jpg')" fit="cover" class="shortImg"></el-image>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                
            }
        },
        mounted(){
            
        },
        methods: {
            
        }
    }
</script>
<style lang="less" scoped>
    .shortContent{
        width: 100vw;
        background: #FAFBFC;
        padding-bottom: 110px;
        .shortBox{
            width: 1228px;
            background: #FFFFFF;
            border-radius: 10px;
            padding: 110px 0 163px 0;
            margin: 0 auto;
            .shortText{
                width: 500px;
                font: 16px/28px simhei;
                color: #464646;
            }
            .shortImg{
                width: 278px;
                margin-top: 50px;
            }
        }
    }
</style>